import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { D80ReductionRatio } from '@app/new-ui/flow-board/reduction-ratio';
import { FragQueryService } from 'src/injectables/frag-query.service';

@Component({
    selector: 'dialog-reduction-ratio',
    templateUrl: './dialog-reduction-ratio.component.html',
    styleUrls: ['./dialog-reduction-ratio.component.scss'],
})
export class DialogReductionRatioComponent {
    public readonly particleSizeUnit$ = this.fragQuery.particleSizeUnit$;

    constructor(
        @Inject(MAT_DIALOG_DATA) public readonly data: D80ReductionRatio,
        public readonly dialogRef: MatDialogRef<DialogReductionRatioComponent>,
        private readonly fragQuery: FragQueryService,
    ) {}
}
